import { MarkerType, MapInstance } from "@/types/map";

export const getMarkerTypeByEvents = (locationEvents: any[]): { markerType: MarkerType; locationType: 0 | 1 | 2 } => {
    const hasDpsEvents = locationEvents.some(
        (event) => parseInt(event.type) === 1
    );

    const hasCleanEvents = locationEvents.some(
        (event) => parseInt(event.type) === 2
    );

    const hasDtpEvents = locationEvents.some(
        (event) => parseInt(event.type) === 3
    );

    let markerType: MarkerType = "dps";

    if (hasDpsEvents) {
        markerType = "dps";
    } else if (hasCleanEvents) {
        markerType = "clean";
    } else if (hasDtpEvents) {
        markerType = "dtp";
    }

    const firstEvent = locationEvents[0];
    const locationType = firstEvent.currentLocation?.type ?? 0;

    return { markerType, locationType: locationType as 0 | 1 | 2 };
};

export const groupEventsByLocation = (events: any[]) => {
    const grouped: { [key: string]: any[] } = {};

    events.forEach((event) => {
        if (!event.locations?.length) {
            console.warn("Событие без locations, пропускаем:", event);
            return;
        }

        event.locations.forEach((location: any) => {
            if (!location.points?.length) {
                console.warn("Локация без points, пропускаем:", location);
                return;
            }

            // Дедупликация координат
            const uniquePoints = new Map<string, any>();

            location.points.forEach((point: any) => {
                if (
                    !point?.latitude ||
                    !point?.longitude ||
                    point.latitude === 0 ||
                    point.longitude === 0 ||
                    isNaN(point.latitude) ||
                    isNaN(point.longitude)
                ) {
                    return;
                }

                const lat = parseFloat(point.latitude.toFixed(4));
                const lng = parseFloat(point.longitude.toFixed(4));
                const pointKey = `${lat}-${lng}`;

                if (!uniquePoints.has(pointKey)) {
                    uniquePoints.set(pointKey, { lat, lng, original: point });
                }
            });

            // Обрабатываем уникальные точки
            uniquePoints.forEach(({ lat, lng, original }) => {
                const key = `${lat}-${lng}-${location.type || 0}`;

                if (!grouped[key]) {
                    grouped[key] = [];
                }


                const eventAlreadyExists = grouped[key].some((existingEvent) => {
                    // Если есть ID - сравниваем по ID
                    if (event.id !== undefined && existingEvent.id !== undefined) {
                        return existingEvent.id === event.id;
                    }
                    // Если нет ID - сравниваем по содержимому
                    return (
                        existingEvent.message === event.message &&
                        existingEvent.from === event.from &&
                        existingEvent.timestamp === event.timestamp
                    );
                });

                if (!eventAlreadyExists) {
                    grouped[key].push({
                        ...event,
                        currentLocation: location,
                        currentPoint: original,
                        currentLocationId: location.id,
                    });
                }
            });
        });
    });

    return grouped;
};

export const isValidCoordinates = (lat: number, lng: number): boolean => {
    return (
        lat !== 0 &&
        lng !== 0 &&
        !isNaN(lat) &&
        !isNaN(lng) &&
        lat >= -90 &&
        lat <= 90 &&
        lng >= -180 &&
        lng <= 180
    );
};

export const centerMapOnMarker = (
    map: MapInstance,
    coordinates: [number, number],
    isMapReady: boolean
) => {
    if (!map || !isMapReady) return;

    try {
        const targetZoom = 14;
        //const latOffset = -0.004;

        const adjustedCenter: [number, number] = [
            coordinates[0],
            coordinates[1] //+ latOffset,
        ];

        map.setCenter(adjustedCenter);
        map.setZoom(targetZoom);

        console.log(
            "🎯 Карта центрирована со смещением:",
            adjustedCenter,
            "зум:",
            targetZoom
        );
    } catch (error) {
        console.warn("Ошибка центрирования карты:", error);
    }
};